import { Observable } from 'rxjs';
import { Repository } from './repository';
import { Injectable } from '@angular/core';
import {
    PaginateData,
    PaginateOption,
    PaginationRepository,
} from '../interfaces/pagination.interface';
import { map } from 'rxjs/operators';
import { Pattern } from '../models/pattern.model';

@Injectable()
export class RouteGroupRepository extends Repository
  implements PaginationRepository {
    paginate(option: PaginateOption): Observable<PaginateData> {
        return this.httpClient
            .get('/routegroup/getbytype', option)
            .pipe(
                map((res: any) => {
                    const patterns = [];
                    if (res.records.groups.routeGroups) {
                        for (const item of res.records.groups.routeGroups) {
                            patterns.push(this.parseResponse(item));
                        }
                    }
                    return {
                        data: patterns,
                        page: res.records.groups.currentPage || 0,
                        total: res.records.groups.totalRecord,
                        pageSize: option.displayItem,
                    };
                })
            );
    };
  getAll(): Observable<Pattern[]> {
    return this.httpClient.get('/routegroup/getall').pipe(
      map((response: any) => {
        const patterns = [];
        let res = response.records;
        if (res.groups) {
          for (const item of res.groups) {
            patterns.push(this.parseResponse(item));
          }
        }
        return patterns;
      })
    );
  }

  duplicatePattern(id: number): Observable<Pattern> {
    return this.httpClient
      .get('/routegroup/duplicate/' + id);
  }

  getInfo(id: Number): Observable<Pattern> {
    return this.httpClient.get('/routegroup/detail/' + id).pipe(
      map((res: any) => {
        return this.parseResponse(res.records.routeGroup);
      })
    );
  }

  updatePattern(pattern: any): Observable<any> {
    return this.httpClient.put('/routegroup/update', pattern);
  }

  createPattern(pattern: any): Observable<any> {
    return this.httpClient.post('/routegroup/create', pattern);
  }

  deletePattern(id: number): Observable<any> {
    return this.httpClient.delete('/routegroup/delete/' + id);
  }

  parseResponse(data: any): Pattern {
    const pattern = new Pattern();
    pattern.fill(data);
    return pattern;
  }
}
